"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const react_rxk_1 = require("react-rxk");
const exec_1 = require("./exec");
;
/**Botón que se muestra deshabilitado por default o mientras se está ejecutando la acción de onClick */
class LogicButtonNoRx extends React.PureComponent {
    constructor(props) {
        super(props);
        this.setStateAsync = (cargando, error) => new Promise(resolve => {
            if (this.mounted) {
                this.setState({ cargando, error }, resolve);
            }
            else
                resolve();
        });
        this.onClick = async () => {
            if (this.props.onClick) {
                await this.setStateAsync(true, false);
                const error = !(await exec_1.execUserFunc(this.props.onClick));
                await this.setStateAsync(false, error);
            }
        };
        this.mounted = false;
        this.state = {};
    }
    componentDidMount() {
        this.mounted = true;
    }
    componentWillUnmount() {
        this.mounted = false;
    }
    render() {
        const disabled = this.props.disabled;
        const props = { onClick: this.onClick, children: this.props.children };
        return (disabled ? this.props.disabledComp(props) :
            this.state.error ? this.props.errorComp(props) :
                this.state.cargando ? this.props.loadingComp(props) :
                    this.props.normalComp(props));
    }
}
/**Botón que se muestra deshabilitado por default o mientras se está ejecutando la acción de onClick. Esta es la base para todos los botones */
exports.LogicButton = react_rxk_1.componentToRx(LogicButtonNoRx, undefined, undefined, { disabled: { initial: true }, children: { initial: null } });



//////////////////
// WEBPACK FOOTER
// ./~/kea-react/dist/botones/logic.js
// module id = 498
// module chunks = 0